import {
  CHANGE_VERSION,
} from './base';

export const TEAM_FIELDS = {
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  MEMBERS: 'members',
  TOTAL_TASKS: 'totalTasks',
  CHANGE_VERSION,
};

export const TEAM_INITIAL_VALUES = {
  [TEAM_FIELDS.NAME]: '',
  [TEAM_FIELDS.DESCRIPTION]: '',
  [TEAM_FIELDS.MEMBERS]: [],
};

export const TEAMS_DEFAULT_SORT_FIELD = TEAM_FIELDS.NAME;

export const TEAM_MODULE_NAME = 'team';

export const TEAM_ASSIGNMENT_FILTERS = {
  UNASSIGNED: 'unassigned',
  ANY: 'any',
  MY: 'my',
};

export const TEAM_ASSIGNMENTS_FILTER_OPTIONS = [
  TEAM_ASSIGNMENT_FILTERS.UNASSIGNED,
  TEAM_ASSIGNMENT_FILTERS.ANY,
  TEAM_ASSIGNMENT_FILTERS.MY,
];
